(function () {
    angular
        .module('BuscaAtivaEscolar')
        .config(function ($stateProvider) {
            $stateProvider.state('manager_confirmation', {
                url: '/confirmacao_gestor_estadual/{id}',
                templateUrl: '/views/state_signup/manager_confirmation.html',
                controller: 'ManagerConfirmationCtrl',
                unauthenticated: true,
            });
        })
        .controller(
            'ManagerConfirmationCtrl',
            function ($scope, $state, $stateParams, StateSignups, ngToast) {
                $scope.prevStep = function () {
                    return $state.go('login');
                };

                $scope.printTerm = function () {
                    const filePath = 'images/termo_de_adesao_bae_2025.pdf'; // Caminho do arquivo PDF

                    const xhr = new XMLHttpRequest();
                    xhr.open('GET', filePath, true);
                    xhr.responseType = 'blob'; // Importante para lidar com arquivos binários

                    xhr.onload = function () {
                        if (xhr.status === 200) {
                            const blob = new Blob([xhr.response], { type: 'application/pdf' });
                            const link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            link.download = 'termo_de_adesao_bae_2025.pdf';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        } else {
                            console.error('Erro ao baixar o arquivo:', xhr.status);
                        }
                    };

                    xhr.onerror = function () {
                        console.error('Erro de rede ao tentar baixar o arquivo.');
                    };

                    xhr.send();
                };

                $scope.provisionState = function () {
                    var confirm = StateSignups.accept({
                        id: $stateParams.id,
                    }).$promise;

                    confirm.then(function (res) {
                        if (res.status === 'ok') {
                            ngToast.success(
                                'A sua solicitação de adesão foi confirmada com sucesso!'
                            );
                            $state.go('login');
                        } else {
                            ngToast.danger('Adesão já realizada');
                        }
                    });
                };
            }
        );
})();